/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCartFull = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m15.538 1.686-.497-.868-.868.496-7.257 4.154-.235.135-.71-2.846L5.78 2H2v2h2.22l2.56 10.242.75 3 .19.758H18v-2H9.28l-.25-1h9.724l.207-.725 2-7L21.326 6h-2.08l-.413 1.443-3.295-5.757zm2.77 7.595L17.246 13H11.81l6.497-3.72zM10.075 13H8.531L7.333 8.21l2.674 4.67.068.12zm1.17-1.981L8.779 6.707l5.521-3.16 2.468 4.312-5.521 3.16zM11 20.499a1.5 1.5 0 1 1-3 .001 1.5 1.5 0 0 1 3 0zm7 0a1.5 1.5 0 1 1-3 .001 1.5 1.5 0 0 1 3 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCartFull as CartFull };
